<template>
    <div class="mt-4">
        <div class="row no-gutters mt-5 animated fadeIn">
            <div class="col-md-10 dark-box-shadow box offset-md-1 border-line">
                <router-link to="/">
                    <button class="btn btn-sm bg-dark pl-3 pr-3 float-left text-white rounded mt-3">
                        <span class="material-icons">arrow_back</span>
                    </button>
                </router-link>
                <h6 class="mt-4 pb-2 text-center text-pink">HAVE SOME QUESTIONS ?</h6>
                <div class="shine-divider"></div>
                <div class="row no-gutters p-md-3 rounded mt-1">
                    <div class="col-md-6">
                        <ContactForm @input="sendMsg" />
                        <div class="mt-3 ml-2">
                            <span v-if="this.$store.getters.getSendMessageStatus.length > 0"
                                class="p-2 text-warning bg-dark box">
                                {{ this.$store.getters.getSendMessageStatus }}
                                <button @click="updateStateNotifyMsgToUser"
                                    class="material-icons ml-3 btn btn-sm btn-dark text-warning"
                                    style="font-size: 15px;">cancel</button>
                            </span>
                        </div>
                    </div>
                    <div class="col-md-6 p-md-3 mb-5 mt-md-0 mt-3">
                        <ul class="pl-3 mt-1 ml-md-4" style="list-style: none">
                            <li class="text-pink">
                                <span class="material-icons float-left">phone</span>
                                <a class="text-pink ml-4" href="tel:09787796698"
                                    style="text-decoration: none;font-size: 13px;">09787796698</a>
                            </li>
                            <li class="mt-3 text-pink">
                                <span class="material-icons float-left">phone</span>
                                <a class="text-pink ml-4" href="tel:09404484402"
                                    style="text-decoration: none;font-size: 13px;">09404484402</a>
                            </li>
                            <li class="mt-3 text-pink">
                                <span class="material-icons float-left">mark_email_unread</span>
                                <a class="text-pink ml-4" href="mailto:aungshine194@gmail.com"
                                    style="text-decoration: none;font-size: 13px;">
                                    aungshine194@gmail.com
                                </a>
                            </li>
                            <li class="mt-3 text-pink">
                                <span class="material-icons float-left">location_on</span>
                                <a href="https://goo.gl/maps/LEnaqGtozwJetNHe7" class="ml-4 text-pink"
                                    style="text-decoration: none;font-size: 13px;">
                                    Myanmar/Mandalay City
                                </a>
                            </li>
                        </ul>
                        <div class="ml-5 mt-4">
                            <router-link to="/profile">
                                <button class="btn btn-sm ml-md-5 text-pink  custom-bg-color">
                                    Profile/> </button>
                            </router-link>
                            <router-link to="/">
                                <button class="btn btn-sm ml-1 text-pink   custom-bg-color">
                                    Home/> </button>
                            </router-link>
                        </div>
                        <div class="mt-4 d-flex ml-5 justify-content-start">
                            <div class="ml-md-5">
                                <a href="tel:+959787796698">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" style="color: #95af04;" height="24"
                                        fill="currentColor" class="bi bi-telephone-outbound-fill mr-4" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd"
                                            d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                                    </svg>
                                </a>
                            </div>
                            <div>
                                <a href="https://t.me/spideyshinedev" target="_blank"> <svg
                                        xmlns="http://www.w3.org/2000/svg" width="24" style="color: #95af04;" height="24"
                                        fill="currentColor" class="bi bi-telegram mr-4" viewBox="0 0 16 16">
                                        <path
                                            d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.287 5.906q-1.168.486-4.666 2.01-.567.225-.595.442c-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294q.39.01.868-.32 3.269-2.206 3.374-2.23c.05-.012.12-.026.166.016s.042.12.037.141c-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8 8 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629q.14.092.27.187c.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.4 1.4 0 0 0-.013-.315.34.34 0 0 0-.114-.217.53.53 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09" />
                                    </svg>
                                </a>
                            </div>
                            <div>
                                <a href="https://github.com/ShineShineDev" target="_blank">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                        style="color: #95af04;" class="mr-4 bi bi-github" viewBox="0 0 16 16">
                                        <path
                                            d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27s1.36.09 2 .27c1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.01 8.01 0 0 0 16 8c0-4.42-3.58-8-8-8" />
                                    </svg>
                                </a>
                            </div>
                            <div>
                                <a href="https://hub.docker.com/u/spideyshine" target="_blank">
                                    <svg widt="24" height="24" xmlns="http://www.w3.org/2000/svg" style="color: #95af04;"
                                        fill="currentColor" viewBox="0 0 640 512">
                                        <path
                                            d="M349.9 236.3h-66.1v-59.4h66.1v59.4zm0-204.3h-66.1v60.7h66.1V32zm78.2 144.8H362v59.4h66.1v-59.4zm-156.3-72.1h-66.1v60.1h66.1v-60.1zm78.1 0h-66.1v60.1h66.1v-60.1zm276.8 100c-14.4-9.7-47.6-13.2-73.1-8.4-3.3-24-16.7-44.9-41.1-63.7l-14-9.3-9.3 14c-18.4 27.8-23.4 73.6-3.7 103.8-8.7 4.7-25.8 11.1-48.4 10.7H2.4c-8.7 50.8 5.8 116.8 44 162.1 37.1 43.9 92.7 66.2 165.4 66.2 157.4 0 273.9-72.5 328.4-204.2 21.4 .4 67.6 .1 91.3-45.2 1.5-2.5 6.6-13.2 8.5-17.1l-13.3-8.9zm-511.1-27.9h-66v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm-78.1-72.1h-66.1v60.1h66.1v-60.1z" />
                                    </svg>
                                </a>
                            </div>
                            <div>
                                <a href="https://shine-shine-dev.blogspot.com/">
                                    <svg class="ml-4" widt="24" height="24" style="color: #95af04;" fill="currentColor"
                                        target="_blank" xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 448 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
                                        <path
                                            d="M162.4 196c4.8-4.9 6.2-5.1 36.4-5.1 27.2 0 28.1 .1 32.1 2.1 5.8 2.9 8.3 7 8.3 13.6 0 5.9-2.4 10-7.6 13.4-2.8 1.8-4.5 1.9-31.1 2.1-16.4 .1-29.5-.2-31.5-.8-10.3-2.9-14.1-17.7-6.6-25.3zm61.4 94.5c-53.9 0-55.8 .2-60.2 4.1-3.5 3.1-5.7 9.4-5.1 13.9 .7 4.7 4.8 10.1 9.2 12 2.2 1 14.1 1.7 56.3 1.2l47.9-.6 9.2-1.5c9-5.1 10.5-17.4 3.1-24.4-5.3-4.7-5-4.7-60.4-4.7zm223.4 130.1c-3.5 28.4-23 50.4-51.1 57.5-7.2 1.8-9.7 1.9-172.9 1.8-157.8 0-165.9-.1-172-1.8-8.4-2.2-15.6-5.5-22.3-10-5.6-3.8-13.9-11.8-17-16.4-3.8-5.6-8.2-15.3-10-22C.1 423 0 420.3 0 256.3 0 93.2 0 89.7 1.8 82.6 8.1 57.9 27.7 39 53 33.4c7.3-1.6 332.1-1.9 340-.3 21.2 4.3 37.9 17.1 47.6 36.4 7.7 15.3 7-1.5 7.3 180.6 .2 115.8 0 164.5-.7 170.5zm-85.4-185.2c-1.1-5-4.2-9.6-7.7-11.5-1.1-.6-8-1.3-15.5-1.7-12.4-.6-13.8-.8-17.8-3.1-6.2-3.6-7.9-7.6-8-18.3 0-20.4-8.5-39.4-25.3-56.5-12-12.2-25.3-20.5-40.6-25.1-3.6-1.1-11.8-1.5-39.2-1.8-42.9-.5-52.5 .4-67.1 6.2-27 10.7-46.3 33.4-53.4 62.4-1.3 5.4-1.6 14.2-1.9 64.3-.4 62.8 0 72.1 4 84.5 9.7 30.7 37.1 53.4 64.6 58.4 9.2 1.7 122.2 2.1 133.7 .5 20.1-2.7 35.9-10.8 50.7-25.9 10.7-10.9 17.4-22.8 21.8-38.5 3.2-10.9 2.9-88.4 1.7-93.9z" />
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="col-md-8 offset-md-2 mt-5 pt-4 pb-5">
                <h4 class="text-center text-pink">Your Messages</h4>
                <div class="shine-hr"></div>
                <div class="card-columns mt-4">
                    <div v-for="(item, index) in getMsg" :key="index" class="card border-0 p-2 box"
                        style="background: rgba(255, 255, 255, 0.1)" id="mouseMoveAni" data-value="5" data-aos="fade-up">
                        <div class="card-body p-1">
                            <p class="text-pink" style="white-space: pre-line">{{ item.msg }}</p>
                            <small class="text-pink float-right">{{ item.date.slice(4) }}</small>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</template>
<script>
import ContactForm from "./../components/ContactForm.vue";
import {InitBrowserAgent} from "./../services/detech-visitors.js";
export default {
    name: 'Contact',
    created() {
        const {browser,language,platform,innerWidth,innerHeight,URL,visitor_generated__id,is_new_visitor,outerWidth,outerHeight,referrer} = InitBrowserAgent(); 
        this.$store.dispatch('initApi', { url: 'https://bot.okjapanstore.com/api/tg/notify', method: 'POST', data: { Noti: 'Alert',URL,browser,language,platform,innerWidth,innerHeight,visitor_generated__id , is_new_visitor,innerWidth,innerHeight,outerWidth,outerHeight,referrer} });
        this.$store.dispatch("initMsg");
    },
    computed: {
        getMsg() {
            return this.$store.getters.getMessage;
        },
    },
    methods: {
        updateStateNotifyMsgToUser() {
            this.$store.dispatch("updateStateNotifyMsgToUser");
        },
        sendMsg: function (event) {
            const msg_schema = {
                name: event.name,
                phone: event.phone,
                msg: event.msg,
                date: new Date().toDateString()
            };
            this.$store.dispatch("sendMsg", msg_schema);
        },
    },
    components: { ContactForm },
};
</script>

<style scoped>
.text-pink {
    color: pink;
}


.shine-divider {
    margin-top: 5px;
    margin-bottom: 3px;
    border: 0px;
    height: 3px;
    background: linear-gradient(to right, rgba(157, 157, 157, 0), #ec4e10, rgba(0, 0, 0, 0));
    background-size: 200% 100%;
    animation: shineAnimation 1.5s infinite alternate;
}

.border-line {
    border-radius: 50%;
    border-left: 3px solid #FF4A01;
    border-right: 3px solid #FF4A01;
    border-radius: 10px;
}

.custom-bg-color {
    background-color: #ff4a01;
}

@keyframes shineAnimation {
    0% {
        background-position: 100% 50%;
    }

    100% {
        background-position: 0 50%;
    }
}
</style>
